module.exports = __webpack_public_path__ + "static/img/newvault.35f8bf3a.png";